export const API_URL = '/api/';

export const MIN_DESCTOP_SCREEN = 1024;
